import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FaChrome, FaFirefoxBrowser } from 'react-icons/fa6';
import './DonateModal.css';

function ExtensionModal({ open, onClose }) {
    useEffect(() => {
        if (!open) return;
        const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', handleKey);
        return () => document.removeEventListener('keydown', handleKey);
    }, [open, onClose]);

    if (!open) return null;

    return createPortal(
        <div className="donate-overlay" onClick={onClose} onTouchEnd={onClose}>
            <div className="donate-modal" onClick={(e) => e.stopPropagation()} onTouchEnd={(e) => e.stopPropagation()}>
                <button className="donate-close" onClick={onClose}>&times;</button>
                <h2 className="donate-title">Automate with ElvenAssist</h2>
                <p className="donate-subtitle">Skip the manual input — the ElvenAssist extension syncs directly with Elvenar and delivers choice recommendations in real time, no app switching needed.</p>
                <p className="donate-subtitle" style={{ fontSize: '0.8em', opacity: 0.75 }}>For desktop users only: ElvenAssist is a browser extension that installs into Chrome or Firefox on your computer — it isn't a separate program to download, and it isn't available on phones or tablets.</p>

                <div className="donate-options">
                    <button
                        className="donate-option chrome"
                        onClick={() => window.open('https://chromewebstore.google.com/detail/elvenassist/kikdpnpfhakidgkojboebobjlknflilc')}>
                        <FaChrome className="donate-icon" style={{ color: '#4285f4' }} />
                        <div className="donate-option-text">
                            <span className="donate-option-title">Chrome</span>
                            <span className="donate-option-desc">Install from Chrome Web Store</span>
                        </div>
                    </button>

                    <button
                        className="donate-option firefox"
                        onClick={() => window.open('https://addons.mozilla.org/en-US/firefox/addon/elven-assist/')}>
                        <FaFirefoxBrowser className="donate-icon" style={{ color: '#ff7139' }} />
                        <div className="donate-option-text">
                            <span className="donate-option-title">Firefox</span>
                            <span className="donate-option-desc">Install from Firefox Add-ons</span>
                        </div>
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}

export default ExtensionModal;
